import { observer } from 'mobx-react-lite'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { CREDIT_USAGE_METRICS_CONFIG } from 'entities/Analytics/lib/constants'
import { type CreditUsageChartDataStore } from 'pages/analytics/pages/creditUsage/ui/Chart/store/creditUsageChartDataStore'
import styles from '../styles.module.scss'

interface CreditUsageBarChartProps {
  chartDataStore: CreditUsageChartDataStore
  hiddenMetrics?: Set<string>
}

export const CreditUsageBarChart = observer(
  ({ chartDataStore, hiddenMetrics = new Set() }: CreditUsageBarChartProps) => {
    const { rechartsData } = chartDataStore

    return (
      <div className={styles.chartContainer}>
        <ResponsiveContainer width='100%' height={300}>
          <BarChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <CartesianGrid vertical horizontal={false} strokeDasharray={'5'} />
            <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
            <YAxis />
            <Tooltip cursor={false} />
            {Object.entries(CREDIT_USAGE_METRICS_CONFIG).map(([key, config]) => {
              if (hiddenMetrics.has(key)) return null

              return (
                <Bar key={key} dataKey={key} fill={config.color} name={config.name} radius={6} />
              )
            })}
          </BarChart>
        </ResponsiveContainer>
      </div>
    )
  }
)
